import { axiosFactory } from '../../../../client';
import {
  ExamPsleResultsDetailsResponse,
  ExamResultsDetailsResponse,
  ExamResultsListingResponse,
} from '../model';
import * as ROUTES from './routes';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api`;
const timeout = 5000;

export const candidateClient = axiosFactory(baseURL, timeout);

export const getExamResultsListing = () =>
  candidateClient.get<ExamResultsListingResponse[]>(ROUTES.GET_EXAM_RESULTS_LISTING);

export const getExamResultsDetails = (examSeries: string, examYear: string, examLevel: string) => {
  const route = `${ROUTES.GET_EXAM_RESULTS}/${examSeries}/${examYear}/${examLevel}`;
  return candidateClient.get<ExamResultsDetailsResponse | ExamPsleResultsDetailsResponse>(route);
};

export const postAuditViewResult = (csrfToken: string, data: undefined) =>
  candidateClient.post(csrfToken, ROUTES.POST_AUDIT_VIEW_RESULT, data);

export const postAuditApplyResit = (csrfToken: string) =>
  candidateClient.post(csrfToken, ROUTES.POST_AUDIT_APPLY_RESIT);
